import { render } from "./TextQuestion.vue?vue&type=template&id=348ed60a&scoped=true"
import script from "./TextQuestion.vue?vue&type=script&lang=js"
export * from "./TextQuestion.vue?vue&type=script&lang=js"

import "./TextQuestion.vue?vue&type=style&index=0&id=348ed60a&lang=scss&scoped=true"

import exportComponent from "/Users/malik/Sites/ismatgroup-satisfaction/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348ed60a"]])

export default __exports__